module.exports = __webpack_public_path__ + "img/custom.a4110b3c.png";